import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//components
import {CoolerLineItemEditComponent} from '../../components/Editors/CoolerLineItemEdit.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseGridComponent }         from '../../baseclasses/BaseGrid.component';

@Component({
  selector: 'my-coolerlineitem-grid',
  templateUrl: './CoolerLineItemGrid.component.html',
  providers: [{provide: BaseGridComponent, useExisting: forwardRef(() => CoolerLineItemGridComponent)}]
})
export class CoolerLineItemGridComponent extends BaseGridComponent {
    lineItems: ent.CoolerLineItem[] = [];
    selectedLineItems: ent.CoolerLineItem[] = [];
    editedLineItem: ent.CoolerLineItem;
    modelGroupFilter: filters.ModelGroupFilter;

    @ViewChild(CoolerLineItemEditComponent) public coolerLineItemEdit: CoolerLineItemEditComponent;

    @Output() public lineItemsChanged: EventEmitter<number> = new EventEmitter();
    
    equipmentTypes: ent.EquipmentType[] = [];
    modelGroups: ent.ModelGroup[] = [];
    specificModelReasons: ent.SpecificModelReason[] = [];
    models: ent.Model[] = [];
    equipmentGraphics: ent.EquipmentGraphics[] = [];
    coolerDoors: ent.CoolerDoor[] = [];
    coolerStyles: ent.CoolerStyle[] = [];

    constructor(private authenticationService: serv.AuthenticationService, private domainDataService: serv.DomainDataService, private router: Router) 
    {
        super();
    }

    ngOnInit(): void {
        this.editedLineItem = new ent.CoolerLineItem();
        this.load();
    }

    public load(){
        
        this.domainDataService.getEquipmentTypes().subscribe(x=> this.onGetEquipmentTypesDone(x));
        var modelGroupFilter: filters.ModelGroupFilter = {SectionID: enums.Section.CoolerLineItems};
        this.domainDataService.getModelGroups(modelGroupFilter).subscribe(x=> this.onGetModelGroupsDone(x));
        this.domainDataService.getSpecificModelReasons().subscribe(x=> this.onGetSpecificModelReasonsDone(x));
        this.domainDataService.getModels({}).subscribe(x=> this.onGetModelsDone(x));
        var egFilter: filters.EquipmentGraphicsFilter = {};
        this.domainDataService.getEquipmentGraphics(egFilter).subscribe(x=> this.onGetEquipmentGraphicsDone(x));
        this.domainDataService.getCoolerDoors({}).subscribe(x=> this.onGetCoolerDoorsDone(x));
        this.domainDataService.getCoolerStyles({}).subscribe(x=> this.onGetCoolerStylesDone(x));

        this.modelGroupFilter = {SectionID: enums.Section.CoolerLineItems};
        this.coolerLineItemEdit.modelGroupDropdown.filter = this.modelGroupFilter;
        this.coolerLineItemEdit.modelGroupDropdown.loadOnDemand();
    }
    
    onGetEquipmentTypesDone(items: ent.EquipmentType[]){
        items.forEach(y=> this.equipmentTypes.push(y));
    }

    onGetModelGroupsDone(items: ent.ModelGroup[]){
      items.forEach(y=> this.modelGroups.push(y));
    }

    onGetSpecificModelReasonsDone(items: ent.SpecificModelReason[]){
        items.forEach(y=> this.specificModelReasons.push(y));
    }

    onGetModelsDone(items: ent.Model[]){
      items.forEach(y=> this.models.push(y));
    }

    onGetEquipmentGraphicsDone(items: ent.EquipmentGraphics[]){
        items.forEach(y=> this.equipmentGraphics.push(y));
    }

    onGetCoolerDoorsDone(items: ent.CoolerDoor[]){
        items.forEach(y=> this.coolerDoors.push(y));
    }

    onGetCoolerStylesDone(items: ent.CoolerStyle[]){
        items.forEach(y=> this.coolerStyles.push(y));
    }

    
    onAddClick(event: any){
      
        this.editedLineItem = new ent.CoolerLineItem();
        this.coolerLineItemEdit.lineItem = new ent.CoolerLineItem();
        this.coolerLineItemEdit.modelDropdown.value = null;
        this.coolerLineItemEdit.modelGroupDropdown.value = null;
        this.coolerLineItemEdit.equipmentGraphicsDropdown.value = null;
        this.coolerLineItemEdit.equipmentTypeDropdown.value = null;
        this.coolerLineItemEdit.specificModelReasonDropdown.value = null;
        this.coolerLineItemEdit.coolerDoorDropdownComponent.value = null;
        this.coolerLineItemEdit.coolerStyleDropdownComponent.value = null;
        this.coolerLineItemEdit.displayDialog = true;

    }

    onDeleteClick(event: any, lineItem: ent.CoolerLineItem){
        this.lineItems = _.remove(this.lineItems, x=>x !== lineItem);
        this.lineItemsChanged.emit(this.lineItems.length);
    }

    onEditClick(event: any, lineItem: ent.CoolerLineItem){
        
        this.editedLineItem = lineItem;
        this.coolerLineItemEdit.lineItem = lineItem;
        this.coolerLineItemEdit.modelDropdown.value = this.editedLineItem.ModelID;
        var models = this.coolerLineItemEdit.modelDropdown.models.filter(x=>x.ID == this.editedLineItem.ModelID);
        if (models.length > 0){
            this.coolerLineItemEdit.model = models[0];
        }
        
        this.coolerLineItemEdit.modelGroupDropdown.value = this.editedLineItem.ModelGroupID;
        this.coolerLineItemEdit.equipmentGraphicsDropdown.value = this.editedLineItem.EquipmentGraphicsID;
        this.coolerLineItemEdit.equipmentTypeDropdown.value = this.editedLineItem.EquipmentTypeID;
        this.coolerLineItemEdit.specificModelReasonDropdown.value = this.editedLineItem.SpecificModelReasonID;
        this.coolerLineItemEdit.coolerDoorDropdownComponent.value = this.editedLineItem.CoolerDoorID;
        this.coolerLineItemEdit.coolerStyleDropdownComponent.value = this.editedLineItem.CoolerStyleID;

        this.coolerLineItemEdit.displayDialog = true;
    }

    onCoolerLineItemEditOK(){
        
        if (this.editedLineItem.EquipmentTypeID && this.editedLineItem.EquipmentTypeID > 0){
            var equipmentType = this.equipmentTypes.filter(x=>x.ID == this.editedLineItem.EquipmentTypeID)[0];
            this.editedLineItem.EquipmentType = {ID: equipmentType.ID, Name: equipmentType.Name};
        }
        if (this.editedLineItem.ModelGroupID && this.editedLineItem.ModelGroupID > 0){
            var modelGroup = this.modelGroups.filter(x=>x.ID == this.editedLineItem.ModelGroupID)[0];
            this.editedLineItem.ModelGroup = {ID: modelGroup.ID, Name: modelGroup.Name, Inactive: false};
        }
        if (this.editedLineItem.SpecificModelReasonID && this.editedLineItem.SpecificModelReasonID > 0){
            var specificModelReason = this.specificModelReasons.filter(x=>x.ID == this.editedLineItem.SpecificModelReasonID)[0];
            this.editedLineItem.SpecificModelReason = {ID: specificModelReason.ID, Name: specificModelReason.Name};
        }
        if (this.editedLineItem.ModelID && this.editedLineItem.ModelID > 0){
            var model = this.models.filter(x=>x.ID == this.editedLineItem.ModelID)[0];
            this.editedLineItem.Model = {ID: model.ID, Name: model.Name, Inactive: false};
        }
        if (this.editedLineItem.EquipmentGraphicsID && this.editedLineItem.EquipmentGraphicsID > 0){
            var equipmentGraphics = this.equipmentGraphics.filter(x=>x.ID == this.editedLineItem.EquipmentGraphicsID)[0];
            this.editedLineItem.EquipmentGraphics = {ID: equipmentGraphics.ID, Name: equipmentGraphics.Name, Code: "", Inactive: equipmentGraphics.Inactive};
        }

        if (this.editedLineItem.CoolerDoorID && this.editedLineItem.CoolerDoorID > 0){
            var coolerDoor = this.coolerDoors.filter(x=>x.ID == this.editedLineItem.CoolerDoorID)[0];
            this.editedLineItem.CoolerDoor = {ID: coolerDoor.ID, Name: coolerDoor.Name, Code: coolerDoor.Code};
        }

        if (this.editedLineItem.CoolerStyleID && this.editedLineItem.CoolerStyleID > 0){
            var coolerStyle = this.coolerStyles.filter(x=>x.ID == this.editedLineItem.CoolerStyleID)[0];
            this.editedLineItem.CoolerStyle = {ID: coolerStyle.ID, Name: coolerStyle.Name, Code: coolerStyle.Code};
        }

        this.lineItems = <ent.CoolerLineItem[]>this.addLineItem(this.editedLineItem, this.lineItems);

        this.lineItemsChanged.emit(this.lineItems.length);
    }

}